let init = false;
let singleton;
let onOpenHooks = [];

class Dropdown {
    #isOpen = false;
    #onOpenHooks = [];

    static closeAll() {
        if (singleton) {
            singleton.close();
        }
    }

    static addOnOpenHook(hook) {
        if (!singleton) {
            onOpenHooks.push(hook);
            return;
        }
        singleton.#onOpenHooks.push(hook);
    }

    close() {
        let self = this;
        if (self.#isOpen) {
            $('.dropdown:not(.hide)').addClass('hide');
            self.#isOpen = false;
        }
    }

    open($el) {
        let self = this;
        let $dropdown = $el.next();
        let position = $el.attr('data-dropdown');
        let width = $el.attr('data-dropdown-width');

        if (!($dropdown.hasClass('frame') && $dropdown.hasClass('hide'))) {
            return;
        }

        $el.parent().css('position', 'relative');
        $dropdown.addClass('dropdown').css({
            position: 'absolute',
            zIndex: 100001,
            minWidth: '140px',
        }).removeClass('hide');

        if (position === 'right') {
            $dropdown.css({
                right: 0
            });
        } else {
            $dropdown.css({
                left: 0
            });
        }

        if (width) {
            $dropdown.css({
                width
            });
        }

        self.#isOpen = true;
        for (let onOpenHook of self.#onOpenHooks) {
            onOpenHook();
        }
    }

    toggle($el) {
        let self = this;
        let $dropdown = $el.next();
        if ($dropdown.hasClass('hide')) {
            self.close();
            self.open($el);
        } else {
            self.close();
        }
    }

    constructor() {
        let self = this;
        if (init) {
            return;
        }

        singleton = self;
        singleton.#onOpenHooks = onOpenHooks;
        init = true;

        $(document).on('click', function(event) {
            let doClose = true;
            $(event.target).parents().each(function(idx, el) {
                if (el == $('.dropdown:not(.hide)')[0]) {
                    doClose = false;
                    return false;
                }
            });
            if (doClose) {
                self.close();
            }
            return true;
        });

        $(document).on('click', '[data-dropdown]', function(event) {
            event.preventDefault();
            event.stopPropagation();
            let $el = $(this);
            self.toggle($el);
        });

        $(document).on('keydown', function(event) {
            if (event.key == 'Escape') {
                self.close();
            }
        });

    }
}

$(document).ready(function(){
    new Dropdown();
});

export default Dropdown;